<template src="./index.html"></template>

<script>
const columns = [
  {
    title: "No",
    key: "no",
    scopedSlots: { customRender: "number" },
    width: "5%",
  },
  {
    title: "Mətn",
    key: "text",
    scopedSlots: { customRender: "comptext" },
    width: "25%",
  },
  {
    title: "Ünvan",
    key: "address",
    scopedSlots: { customRender: "address" },
    width: "30%",
  },
  {
    title: "Müraciət sayı",
    key: "count",
    dataIndex: "appealCount",
    width: "10%",
  },
  {
    title: "Müraciət tarixi",
    key: "date",
    dataIndex: "appealDate",
    width: "15%",
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: "10%",
  },
];
import { URL, apiCall } from "@/utils/api";
import DetailModal from "@/components/pages/Modals/DetailModal/index";
export default {
  name: "CitizenAppealsTable",
  props: {
    dataSource: Array,
    loading: Boolean,
  },
  components: {
    "detail-modal": DetailModal,
  },
  data() {
    return {
      columns,
      modalVisible: false,
      mylocale: { emptyText: "Məlumat yoxdur" },
      problem: null,
    };
  },
  methods: {
    getDetailed(record) {
      this.problem = record;
      this.modalVisible = true;
    },
    handleModalClose() {
      this.modalVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
